import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

interface BadgePageProps {}

export default function BadgePage({}: BadgePageProps) {
  const { badgeId } = useParams();
  // Em produção, você buscaria esses dados do seu backend
  const badge = {
    name: 'HTML Master',
    description: 'Completed all HTML fundamentals courses with excellence',
    image: `https://api.dicebear.com/7.x/shapes/svg?seed=html-master`, // Substitua pela URL real da imagem
    url: `https://programe.tech/badges/${badgeId}`,
  };

  return (
    <>
      <Helmet>
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={badge.url} />
        <meta property="og:title" content={badge.name} />
        <meta property="og:description" content={badge.description} />
        <meta property="og:image" content={badge.image} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={badge.url} />
        <meta property="twitter:title" content={badge.name} />
        <meta property="twitter:description" content={badge.description} />
        <meta property="twitter:image" content={badge.image} />

        {/* LinkedIn */}
        <meta property="linkedin:card" content="summary_large_image" />
        <meta property="linkedin:title" content={badge.name} />
        <meta property="linkedin:description" content={badge.description} />
        <meta property="linkedin:image" content={badge.image} />
      </Helmet>

      {/* Rest of your badge display page */}
      <div className="container mx-auto p-4 mt-12 sm:mt-16">
        <div className="card bg-base-200 shadow-xl">
          <div className="card-body">
            <h1 className="text-3xl font-bold text-primary">{badge.name}</h1>
            <p className="text-base-content/70">{badge.description}</p>
            <img src={badge.image} alt={badge.name} className="w-32 h-32 mx-auto" />
          </div>
        </div>
      </div>
    </>
  );
} 